export class Modal2 {
    constructor (x){
        
        this._onESCkeydown = this._onESCkeydown.bind(this);
        // this.active = this.active.bind(this);

        this.modal = document.querySelector('.modal2');
        
        if (!this.modal){
            const newModal = document.createElement("div");
            newModal.classList.add('modal2');
            newModal.innerHTML = ''
                +'<a href="#" class="modal2_cb modalAction" data-modalaction="modal-close"><span></span></a>'
                +'<div class="modal2_body_wrap">'
                    +'<div class="modal2_body">'
                    +x
                    +'</div>'
                +'</div>'; 

            // newModal.querySelector('.modal2_body').append(x);
            document.body.appendChild(newModal);
            this.modal = newModal;
           
        }
        
      
        this.modal = document.querySelector('.modal2');
        this.hasScrollbar = document.body.scrollHeight > window.innerHeight;
        
        // this.modal.querySelector('[data-modalaction="modal-close"]').addEventListener('click', (e) => {
        //     e.preventDefault();
        //     this.close();
        // });

        document.addEventListener("keydown", this._onESCkeydown, false);
    }

    _onESCkeydown(e) {
        e = e || window.event;
        if (e.keyCode == 27 && this.modal.classList.contains('active')) {
            this.close();
        }
    }

    close() {

        this.modal.style.opacity = 0;
        document.removeEventListener("keydown", this._onESCkeydown, false);


        setTimeout(()=> {
            this.modal.remove();
        }, 350);

    }


    active() {
        this.modal.classList.add('active');
        if (this.hasScrollbar){
            document.body.classList.add('fixed');
        }

        this.modal.querySelectorAll('[data-modalaction="modal-close"]').forEach(modalClose => {
            modalClose.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }) 
    }

}
